(() => {
  const PAGE_SIZE = 5;
  const root = document.querySelector('[data-archive-watchlist-page]');
  if (!root) return;

  const container = root.querySelector('#archive-watchlist-container');
  const clearModal = document.getElementById('archive-clear-watchlist-modal');
  const clearDialog = clearModal?.querySelector('.archive-clear-modal__dialog');
  const closeClearButton = document.getElementById('archive-close-clear-modal');
  const keepButton = document.getElementById('archive-keep-watchlist');
  const confirmClearButton = document.getElementById('archive-confirm-clear-watchlist');
  const clearModalCount = document.getElementById('archive-clear-modal-count');
  const clearModalItemLabel = document.getElementById('archive-clear-modal-item-label');
  const toast = document.getElementById('archive-watchlist-toast');
  const toastClose = toast?.querySelector('.archive-watchlist-toast__close');
  const preservationSignIn = document.querySelector('[data-archive-watchlist-preserve]');
  const statusHeading = root.querySelector('[data-archive-watchlist-status-heading]');
  const statusCopy = root.querySelector('[data-archive-watchlist-status-copy]');
  const statusCta = root.querySelector('[data-archive-watchlist-status-cta]');
  const isAuthenticated = root.dataset.archiveWatchlistAuthenticated === 'true';
  let items = [];
  let sortField = 'addedAt';
  let sortDirection = 'desc';
  let currentPage = 1;
  let clearTrigger = null;
  let previousBodyOverflow = '';
  let previousBodyPaddingRight = '';
  let activeTitleTarget = null;
  let titlePopover = null;

  preservationSignIn?.addEventListener('click', event => {
    const intent = window.ArchiveOwnership
      ?.createWatchlistPreservationIntent(window.location.pathname);
    if (!intent) return;

    event.preventDefault();
    const authenticationUrl = new URL(preservationSignIn.href, window.location.origin);
    const returnUrl = new URL(intent.returnPath, window.location.origin);
    returnUrl.searchParams.set('archiveHandoff', intent.nonce);
    authenticationUrl.searchParams.set(
      'return_to',
      `${returnUrl.pathname}${returnUrl.search}`
    );
    window.location.assign(authenticationUrl.href);
  });
  let toastTimer = null;

  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const addIcon = (element, markup) => {
    element.innerHTML = markup;
    element.setAttribute('aria-hidden', 'true');
  };
  const text = value => value === null || value === undefined ? '' : String(value).trim();
  const safeUrl = (value, image = false) => {
    const candidate = text(value);
    if (!candidate) return null;
    try {
      const url = new URL(candidate, window.location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return null;
      if (image) return url.href;
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : null;
    } catch (_) {
      return null;
    }
  };
  const formatDate = value => {
    if (!text(value)) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const sortItems = source => [...source].sort((a, b) => {
    let aValue;
    let bValue;
    switch (sortField) {
      case 'name':
        aValue = text(a.title).toLowerCase();
        bValue = text(b.title).toLowerCase();
        break;
      case 'price':
        aValue = Number(text(a.price).replace(/[^0-9.]/g, ''));
        bValue = Number(text(b.price).replace(/[^0-9.]/g, ''));
        break;
      case 'region':
        aValue = text(a.region).toLowerCase();
        bValue = text(b.region).toLowerCase();
        break;
      default:
        aValue = new Date(a.addedAt || 0).getTime();
        bValue = new Date(b.addedAt || 0).getTime();
    }
    if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  const pageCountFor = count => Math.max(1, Math.ceil(count / PAGE_SIZE));
  const compactPages = (current, count) => {
    if (count <= 7) return Array.from({ length: count }, (_, index) => index + 1);
    const pages = [...new Set([1, count, current - 1, current, current + 1])]
      .filter(page => page > 0 && page <= count).sort((a, b) => a - b);
    return pages.flatMap((page, index) => index && page - pages[index - 1] > 1 ? ['ellipsis', page] : [page]);
  };
  const countLabel = count => `${count} ${count === 1 ? 'Expression' : 'Expressions'} Preserved`;

  function buildCount() {
    const count = create('p', 'archive-watchlist-count');
    const icon = create('span', 'archive-watchlist-count__icon');
    addIcon(icon, '<svg viewBox="0 0 16 20" focusable="false"><path d="M2.5 1.5h11v16l-5.5-3.7-5.5 3.7v-16Z"/></svg>');
    count.append(icon, document.createTextNode(countLabel(items.length)));
    return count;
  }

  function buildToolbar() {
    const toolbar = create('div', 'archive-watchlist-toolbar');
    toolbar.appendChild(buildCount());
    const sort = create('div', 'archive-watchlist-sort');
    sort.setAttribute('role', 'group');
    sort.setAttribute('aria-label', 'Sort Watchlist');
    [['addedAt', 'Preserved'], ['region', 'Region'], ['price', 'Price'], ['name', 'Name']].forEach(([field, label]) => {
      const active = sortField === field;
      const button = create('button', `archive-sort-button${active ? ' active' : ''}`);
      button.type = 'button';
      button.dataset.sort = field;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? `Sort by ${label}, currently ${sortDirection === 'asc' ? 'ascending' : 'descending'}` : `Sort by ${label}`);
      button.appendChild(document.createTextNode(label));
      if (active) {
        const direction = create('span', 'archive-sort-button__direction', sortDirection === 'asc' ? '↑' : '↓');
        direction.setAttribute('aria-hidden', 'true');
        button.appendChild(direction);
      }
      sort.appendChild(button);
    });
    toolbar.appendChild(sort);
    const clear = create('button', 'archive-clear-watchlist');
    clear.type = 'button';
    clear.dataset.clearWatchlist = '';
    addIcon(clear, '<svg viewBox="0 0 20 20" focusable="false"><path d="M3.5 5.5h13M8 3h4l1 2.5H7L8 3Zm-2 2.5.8 11h6.4l.8-11M8.3 8.2v5.6m3.4-5.6v5.6"/></svg><span>Clear Watchlist</span>');
    toolbar.appendChild(clear);
    return toolbar;
  }

  function buildMeta(type, value) {
    const row = create('p', `archive-watchlist-card__meta-row archive-watchlist-card__meta-row--${type}`);
    const icon = create('span');
    addIcon(icon, type === 'region'
      ? '<svg viewBox="0 0 20 20"><path d="M10 18s5-5.7 5-10a5 5 0 1 0-10 0c0 4.3 5 10 5 10Z"/><circle cx="10" cy="8" r="1.5"/></svg>'
      : '<svg viewBox="0 0 20 20"><rect x="3" y="5" width="14" height="12" rx="1"/><path d="M6 3v4m8-4v4M3 9h14"/></svg>');
    row.append(icon, document.createTextNode(value));
    return row;
  }

  function buildCard(item) {
    const title = text(item.title) || 'Archive expression';
    const productUrl = safeUrl(item.url);
    const imageUrl = safeUrl(item.image, true);
    const article = create('article', 'archive-watchlist-card');
    const media = create(productUrl ? 'a' : 'div', productUrl ? 'archive-watchlist-card__media archive-watchlist-card__media-link' : 'archive-watchlist-card__media');
    if (productUrl) {
      media.href = productUrl;
      media.setAttribute('aria-label', `View ${title}`);
    }
    const placeholder = create('span', 'archive-watchlist-card__placeholder');
    placeholder.setAttribute('aria-hidden', 'true');
    media.appendChild(placeholder);
    if (imageUrl) {
      const image = create('img', 'archive-watchlist-card__image');
      image.src = imageUrl;
      image.alt = title;
      image.loading = 'lazy';
      image.addEventListener('error', () => image.remove(), { once: true });
      media.appendChild(image);
    }
    const communityRating = window.ArchiveCommunityRating?.create(
      item.whiskybaseScore,
      item.communityReferenceEnabled
    );
    if (communityRating) media.appendChild(communityRating);
    const content = create('div', 'archive-watchlist-card__content');
    const heading = create('h2', 'archive-watchlist-card__title');
    heading.dataset.fullTitle = title;
    if (productUrl) {
      const link = create('a', '', title);
      link.href = productUrl;
      heading.appendChild(link);
    } else heading.textContent = title;
    content.appendChild(heading);
    if (text(item.price)) content.appendChild(create('p', 'archive-watchlist-card__price', text(item.price)));
    const region = text(item.region);
    const date = formatDate(item.addedAt);
    if (region || date) {
      const meta = create('div', 'archive-watchlist-card__meta');
      if (region) meta.appendChild(buildMeta('region', region));
      if (date) meta.appendChild(buildMeta('date', `Preserved on ${date}`));
      content.appendChild(meta);
    }
    const actions = create('div', 'archive-watchlist-card__actions');
    if (productUrl) {
      const view = create('a', 'archive-watchlist-view', 'View Expression →');
      view.href = productUrl;
      actions.appendChild(view);
    }
    const remove = create('button', 'archive-watchlist-remove', 'Remove');
    remove.type = 'button';
    remove.dataset.removeProduct = text(item.id);
    remove.setAttribute('aria-label', `Remove ${title} from Watchlist`);
    actions.appendChild(remove);
    content.appendChild(actions);
    const ribbon = create('span', 'archive-watchlist-card__ribbon');
    addIcon(ribbon, '<svg viewBox="0 0 18 24"><path d="M3 2h12v19l-6-4-6 4V2Z"/></svg>');
    article.append(media, content, ribbon);
    return article;
  }

  function buildPagination(total, pageCount) {
    const wrap = create('div', 'archive-watchlist-pagination-wrap');
    if (pageCount > 1) {
      const nav = create('nav', 'archive-pagination');
      nav.setAttribute('aria-label', 'Watchlist pagination');
      const addButton = (label, page, className, ariaLabel, current = false) => {
        const button = create('button', className, label);
        button.type = 'button';
        button.dataset.page = String(page);
        button.setAttribute('aria-label', ariaLabel);
        if (current) {
          button.setAttribute('aria-current', 'page');
          button.disabled = true;
        }
        nav.appendChild(button);
      };
      if (currentPage > 1) addButton('← Previous', currentPage - 1, 'archive-pagination-prev', 'Previous Watchlist page');
      compactPages(currentPage, pageCount).forEach(value => {
        if (value === 'ellipsis') {
          const ellipsis = create('span', 'archive-pagination-ellipsis', '…');
          ellipsis.setAttribute('aria-hidden', 'true');
          nav.appendChild(ellipsis);
        } else {
          const current = value === currentPage;
          addButton(String(value), value, `archive-pagination-page${current ? ' current' : ''}`, current ? `Page ${value}, current page` : `Watchlist page ${value}`, current);
        }
      });
      if (currentPage < pageCount) addButton('Next →', currentPage + 1, 'archive-pagination-next', 'Next Watchlist page');
      wrap.appendChild(nav);
    }
    const first = (currentPage - 1) * PAGE_SIZE + 1;
    const last = Math.min(currentPage * PAGE_SIZE, total);
    wrap.appendChild(create('p', 'archive-watchlist-pagination__status', `Showing ${first}–${last} of ${total} ${total === 1 ? 'expression' : 'expressions'}`));
    return wrap;
  }

  function renderEmpty() {
    container.replaceChildren(buildCount());
    const empty = create('div', 'archive-watchlist-empty');
    const bookmark = create('span', 'archive-watchlist-empty__bookmark');
    addIcon(bookmark, '<svg viewBox="0 0 42 52"><path d="M8 3h26v44L21 38 8 47V3Z"/><path d="m16 21 4 2 4-2-.8 4.5 3.3 3.2-4.6.7-2 4.1-2-4.1-4.6-.7 3.3-3.2-.8-4.5Z"/></svg>');
    const heading = create('h2', '', 'Your Archive Watchlist is currently empty.');
    heading.tabIndex = -1;
    empty.append(bookmark, heading, create('p', '', 'Save expressions throughout the Archive to revisit them at a later time.'));
    const explore = create('a', 'archive-watchlist-primary-button', 'Browse All Whisky');
    explore.href = '/collections/all';
    empty.appendChild(explore);
    container.appendChild(empty);
  }

  function render() {
    root.classList.toggle('archive-watchlist-page--empty', !items.length);
    if (!items.length) {
      currentPage = 1;
      renderEmpty();
      return;
    }
    const sorted = sortItems(items);
    const pageCount = pageCountFor(sorted.length);
    currentPage = Math.min(Math.max(currentPage, 1), pageCount);
    const start = (currentPage - 1) * PAGE_SIZE;
    const fragment = document.createDocumentFragment();
    fragment.appendChild(buildToolbar());
    const grid = create('div', 'archive-watchlist-grid');
    grid.setAttribute('aria-label', 'Preserved expressions');
    grid.tabIndex = -1;
    sorted.slice(start, start + PAGE_SIZE).forEach(item => grid.appendChild(buildCard(item)));
    fragment.append(grid, buildPagination(sorted.length, pageCount));
    container.replaceChildren(fragment);
    requestAnimationFrame(() => {
      try {
        updateTruncatedTitles();
      } catch (error) {
        console.warn('Unable to enhance truncated Watchlist titles.', error);
      }
    });
  }

  function updateStatusPanel(detail) {
    if (!statusHeading || !statusCopy) return;
    if (isAuthenticated) {
      const accountConfirmed = detail.status === 'ready' &&
        ['cloud-initialized', 'subscribe', 'saved', 'storage', 'pageshow'].includes(detail.source);
      if (detail.source === 'save-failed') {
        statusHeading.textContent = 'Your Watchlist change could not be saved';
        statusCopy.textContent = 'Your previous Watchlist has been restored. Please try again.';
      } else if (accountConfirmed) {
        statusHeading.textContent = 'Your Watchlist is saved to your Archive account';
        statusCopy.textContent = 'Access your saved expressions across devices and browsers.';
      } else if (detail.status === 'ready') {
        statusHeading.textContent = 'Saving changes to your Archive account…';
        statusCopy.textContent = 'Your Watchlist will update when saving completes.';
      } else {
        statusHeading.textContent = 'Your account Watchlist is temporarily unavailable';
        statusCopy.textContent = 'Please refresh the page to try again.';
      }
      return;
    }

    if (items.length > 0) {
      statusHeading.textContent = 'Your Watchlist is saved in this browser';
      statusCopy.textContent = 'Your expressions will be here when you return on this device.';
      if (statusCta) statusCta.textContent = 'Sign in to preserve your Watchlist →';
    } else {
      statusHeading.textContent = 'Already have a saved Watchlist?';
      statusCopy.textContent = 'Sign in to access expressions preserved with your Archive account.';
      if (statusCta) statusCta.textContent = 'Sign in to your Archive →';
    }
  }

  function ensureTitlePopover() {
    if (titlePopover?.isConnected) return titlePopover;
    const popover = document.createElement('div');
    popover.className = 'archive-watchlist-title-popover';
    popover.id = 'archive-watchlist-title-popover';
    popover.setAttribute('role', 'tooltip');
    popover.hidden = true;
    document.body.appendChild(popover);
    titlePopover = popover;
    return popover;
  }

  function updateTruncatedTitles() {
    container.querySelectorAll('.archive-watchlist-card__title').forEach(heading => {
      const truncated = heading.scrollWidth > heading.clientWidth + 1 || heading.scrollHeight > heading.clientHeight + 1;
      heading.dataset.truncated = truncated ? 'true' : 'false';
      if (!heading.querySelector('a')) heading.tabIndex = truncated ? 0 : -1;
    });
  }

  function showTitlePopover(heading) {
    if (heading?.dataset.truncated !== 'true' || window.matchMedia('(max-width: 749px)').matches) return;
    let popover;
    try {
      popover = ensureTitlePopover();
    } catch (error) {
      console.warn('Unable to show the Watchlist title disclosure.', error);
      return;
    }
    activeTitleTarget = heading;
    popover.textContent = heading.dataset.fullTitle || heading.textContent;
    popover.hidden = false;
    (heading.querySelector('a') || heading).setAttribute('aria-describedby', popover.id);
    const target = heading.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    const gap = 9;
    const left = Math.min(Math.max(12, target.left), window.innerWidth - popoverRect.width - 12);
    const openAbove = target.bottom + gap + popoverRect.height > window.innerHeight && target.top > popoverRect.height + gap;
    popover.style.left = `${left}px`;
    popover.style.top = `${openAbove ? target.top - popoverRect.height - gap : target.bottom + gap}px`;
    popover.dataset.placement = openAbove ? 'above' : 'below';
  }

  function hideTitlePopover() {
    activeTitleTarget?.removeAttribute('aria-describedby');
    activeTitleTarget?.querySelector('a')?.removeAttribute('aria-describedby');
    activeTitleTarget = null;
    if (titlePopover) titlePopover.hidden = true;
  }

  container.addEventListener('pointerover', event => {
    const heading = event.target.closest('.archive-watchlist-card__title');
    if (heading) showTitlePopover(heading);
  });
  container.addEventListener('pointerout', event => {
    const heading = event.target.closest('.archive-watchlist-card__title');
    if (heading && !heading.contains(event.relatedTarget)) hideTitlePopover();
  });
  container.addEventListener('focusin', event => {
    const heading = event.target.closest('.archive-watchlist-card__title');
    if (heading) showTitlePopover(heading);
  });
  container.addEventListener('focusout', event => {
    const heading = event.target.closest('.archive-watchlist-card__title');
    if (heading && !heading.contains(event.relatedTarget)) hideTitlePopover();
  });
  container.addEventListener('keydown', event => {
    if (event.key === 'Escape' && activeTitleTarget) {
      event.preventDefault();
      hideTitlePopover();
    }
  });
  window.addEventListener('resize', () => {
    hideTitlePopover();
    try {
      updateTruncatedTitles();
    } catch (error) {
      console.warn('Unable to refresh truncated Watchlist titles.', error);
    }
  });

  function hideToast() {
    if (!toast || toast.hidden) return;
    window.clearTimeout(toastTimer);
    toast.classList.remove('visible');
    window.setTimeout(() => { toast.hidden = true; }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 230);
  }
  function showToast() {
    if (!toast) return;
    window.clearTimeout(toastTimer);
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add('visible'));
    toastTimer = window.setTimeout(hideToast, 5000);
  }
  function openClearModal(trigger) {
    clearTrigger = trigger;
    clearModalCount.textContent = String(items.length);
    clearModalItemLabel.textContent = items.length === 1 ? 'expression' : 'expressions';
    previousBodyOverflow = document.body.style.overflow;
    previousBodyPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
    clearModal.hidden = false;
    keepButton.focus();
  }
  function closeClearModal(restoreFocus = true) {
    clearModal.hidden = true;
    confirmClearButton.disabled = false;
    keepButton.disabled = false;
    document.body.style.overflow = previousBodyOverflow;
    document.body.style.paddingRight = previousBodyPaddingRight;
    if (restoreFocus && clearTrigger?.isConnected) clearTrigger.focus();
    clearTrigger = null;
  }

  container.addEventListener('click', async event => {
    const sortButton = event.target.closest('[data-sort]');
    if (sortButton) {
      const selected = sortButton.dataset.sort;
      if (sortField === selected) sortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
      else {
        sortField = selected;
        sortDirection = selected === 'addedAt' ? 'desc' : 'asc';
      }
      currentPage = 1;
      render();
      container.querySelector(`[data-sort="${selected}"]`)?.focus();
      return;
    }
    const pageButton = event.target.closest('[data-page]');
    if (pageButton) {
      currentPage = Number(pageButton.dataset.page) || 1;
      render();
      container.querySelector('.archive-watchlist-grid')?.focus();
      return;
    }
    const clearButton = event.target.closest('[data-clear-watchlist]');
    if (clearButton) {
      openClearModal(clearButton);
      return;
    }
    const removeButton = event.target.closest('[data-remove-product]');
    if (removeButton) {
      const oldButtons = [...container.querySelectorAll('[data-remove-product]')];
      const oldIndex = oldButtons.indexOf(removeButton);
      removeButton.disabled = true;
      removeButton.setAttribute('aria-busy', 'true');
      const removed = await window.ArchiveWatchlist.remove(removeButton.dataset.removeProduct);
      if (!removed) {
        const restored = [...container.querySelectorAll('[data-remove-product]')].find(button => button.dataset.removeProduct === removeButton.dataset.removeProduct);
        if (restored) {
          restored.disabled = false;
          restored.removeAttribute('aria-busy');
          restored.focus();
        }
      }
      if (removed) {
        showToast();
        const nextButtons = [...container.querySelectorAll('[data-remove-product]')];
        if (nextButtons.length) nextButtons[Math.min(oldIndex, nextButtons.length - 1)].focus();
        else container.querySelector('.archive-watchlist-empty h2')?.focus();
      }
    }
  });

  keepButton?.addEventListener('click', () => closeClearModal());
  closeClearButton?.addEventListener('click', () => closeClearModal());
  toastClose?.addEventListener('click', hideToast);
  confirmClearButton?.addEventListener('click', async () => {
    confirmClearButton.disabled = true;
    keepButton.disabled = true;
    currentPage = 1;
    const cleared = await window.ArchiveWatchlist.clear();
    closeClearModal(false);
    if (cleared) container.querySelector('.archive-watchlist-empty h2')?.focus();
    else container.querySelector('[data-clear-watchlist]')?.focus();
  });
  clearModal?.addEventListener('click', event => { if (event.target === clearModal) closeClearModal(); });
  clearModal?.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeClearModal();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [closeClearButton, keepButton, confirmClearButton].filter(button => button && !button.disabled);
    if (!focusable.length) {
      event.preventDefault();
      clearDialog?.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (!window.ArchiveWatchlist) {
    renderEmpty();
    updateStatusPanel({ status: 'unavailable' });
    return;
  }
  window.ArchiveWatchlist.subscribe(detail => {
    if (detail.status === 'initializing') return;
    items = Array.isArray(detail.items) ? detail.items : [];
    try {
      updateStatusPanel(detail);
    } catch (error) {
      console.warn('Unable to update the Watchlist status panel.', error);
    }
    if (detail.source === 'clear') currentPage = 1;
    currentPage = Math.min(currentPage, pageCountFor(items.length));
    render();
  });
})();
